import { render } from "./GroupsAddName.vue?vue&type=template&id=716ecd02&scoped=true&ts=true"
import script from "./GroupsAddName.vue?vue&type=script&lang=ts"
export * from "./GroupsAddName.vue?vue&type=script&lang=ts"

import "./GroupsAddName.vue?vue&type=style&index=0&id=716ecd02&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716ecd02"]])

export default __exports__